// extracted by mini-css-extract-plugin
export var button = "_by-0";
export var icon = "_by-1";